// extracted by mini-css-extract-plugin
export default {"image":"ImageSkeleton_image__2B0cX","slide":"ImageSkeleton_slide__tAfEL"};